(function () {
  'use strict';

  function initConfigurator(configurator) {
    if (configurator.dataset.initialized === 'true') return;
    configurator.dataset.initialized = 'true';

    const sectionId = configurator.dataset.sectionId;
    if (!sectionId) return;

    // --- 1. GET ELEMENTS ---
    const razorInputs = configurator.querySelectorAll(`input[name="razor-${sectionId}"]`);
    const addonCheckboxes = Array.from(configurator.querySelectorAll('.addon-checkbox'));

    const totalPriceEl = configurator.querySelector('.total-price');
    const totalCompareAtEl = configurator.querySelector('.total-compare-at-price');
    const mainImageWrapper = document.getElementById(`MainImageWrapper-${sectionId}`);
    const thumbnailsWrapper = document.getElementById(`Thumbnails-${sectionId}`);

    const addToCartBtn = configurator.querySelector('.add-to-cart-button');
    const infoIcons = configurator.querySelectorAll('.info-icon');
    const drawer = configurator.querySelector('.info-drawer');
    const drawerCloseBtn = configurator.querySelector('.drawer-close');
    const drawerOverlay = configurator.querySelector('.drawer-overlay');
    const drawerContent = configurator.querySelector('.drawer-content');
    const drawerImg = drawer.querySelector('.drawer-image');
    const drawerTitle = drawer.querySelector('.drawer-title');
    const drawerDescription = drawer.querySelector('.drawer-description');

    // Null whenever the section's "Proudly made in Canada" toggle is off — Liquid
    // doesn't render the element at all in that case.
    const canadaBadge = document.getElementById(`CanadaBadge-${sectionId}`);

    const selectedColorNameEl = document.getElementById(`selected-color-name-${sectionId}`);
    const productDescriptionEl = document.getElementById(`product-description-${sectionId}`);

    // --- 2. LOAD DATA ---
    let productData = {};
    try {
      const productDataEl = document.getElementById(`ProductJson-${sectionId}`);
      productData = JSON.parse(productDataEl.textContent).reduce((acc, product) => {
        acc[product.handle] = product;
        return acc;
      }, {});
    } catch (e) { console.error("Error loading product data", e); }

    let blockOverrides = {};
    try {
      blockOverrides = JSON.parse(document.getElementById(`BlockOverrides-${sectionId}`).textContent);
    } catch (e) { console.error("Error loading block overrides", e); }

    const configHeading = configurator.dataset.heading || '';
    const refreshReviews = configurator.dataset.refreshReviews === 'true';

    let state = {
      handle: null,
      colorName: ''
    };

    let mainWidgetHeightLocked = false;
    let badgeSizeLocked = false;
    let lastStampedHandle = null;
    let lastComplementaryHandle = null;
    let complementaryAbortController = null;

    // Stamped resolves a product's review *group* from data-id / data-product-id
    // alone. A real variant SKU in data-product-sku narrows the response to
    // reviews recorded against that one SKU and skips the group entirely —
    // /api/widget for henson-al13-in-aircraft-aluminum returns 4,033 reviews with
    // the SKU and 20,381 without it. Stamped's main-widget app block emits the
    // variant SKU (and the Liquid badge used to), so the un-grouped count is what
    // rendered on first paint; the swap below never set a real SKU, which is why
    // touching any swatch "fixed" the number.
    const STAMPED_SKU_ATTRS = ['data-product-sku', 'data-product-sku2'];

    function getStampedTargets() {
      const badge = configurator.querySelector('.stamped-main-badge');
      const mainWidget = document.querySelector('#stamped-main-widget, .stamped-main-widget');
      return [badge, mainWidget].filter(Boolean);
    }

    // The attributes Stamped turns into query params — id/name/type decide which
    // reviews come back, so this is all the first-paint fix needs to touch.
    function applyStampedIdentity(el, product) {
      el.setAttribute('data-id', product.id);
      el.setAttribute('data-product-id', product.id);
      el.setAttribute('data-name', product.title);
      el.setAttribute('data-product-title', product.title);
      el.setAttribute('data-product-type', product.type || '');
      STAMPED_SKU_ATTRS.forEach(attr => el.removeAttribute(attr));
    }

    // Plus the presentational attrs Stamped reads for share links and the review
    // form, which the swap path has to move onto the newly selected product.
    function applyStampedProduct(el, product) {
      applyStampedIdentity(el, product);
      if (product.url) el.setAttribute('data-url', product.url);
      if (product.featured_image) el.setAttribute('data-image-url', product.featured_image);
      if (product.description) el.setAttribute('data-description', product.description);
    }

    function reloadStamped() {
      try {
        if (window.StampedFn) {
          if (typeof StampedFn.loadBadges === 'function') StampedFn.loadBadges();
          if (typeof StampedFn.loadWidget === 'function') StampedFn.loadWidget();
        }
      } catch (e) { console.warn('[Stamped swap] reload call failed', e); }
    }

    // First paint: correct the attributes Liquid and the app block emitted before
    // Stamped ever reads them. This file is deferred, so it runs at readyState
    // 'interactive' while Stamped initialises on jQuery ready (DOMContentLoaded)
    // — the attrs are already right when it fetches, so there's no flash of a
    // wrong count and no duplicate request. If Stamped did get there first (warm
    // cache, theme-editor re-render) the widgets already have children, so reload
    // them the same way a swatch change would.
    function primeStampedWidgets(product) {
      const targets = getStampedTargets();
      if (!targets.length) return;

      let alreadyRendered = false;
      targets.forEach(el => {
        if (el.children.length > 0) alreadyRendered = true;
        // Rewriting identity is only right where the selection drives the
        // reviews; on shared-review pages the app block's own product stands and
        // all that needs undoing is the SKU narrowing.
        if (refreshReviews && product) applyStampedIdentity(el, product);
        else STAMPED_SKU_ATTRS.forEach(attr => el.removeAttribute(attr));
      });

      if (refreshReviews && product) lastStampedHandle = product.handle;
      if (alreadyRendered) reloadStamped();
    }

    function refreshStampedWidgets(product) {
      if (!refreshReviews || !product) return;
      if (lastStampedHandle === product.handle) return;

      const targets = getStampedTargets();
      if (!targets.length) {
        console.warn('[Stamped swap] no targets found');
        return;
      }
      const badge = targets.find(el => el.classList.contains('stamped-main-badge'));
      const mainWidget = targets.find(el => el !== badge);

      console.log('[Stamped swap] to', product.handle, 'id', product.id, 'targets', targets.length);

      // Lock main widget height on first swap to prevent page shift
      if (mainWidget && !mainWidgetHeightLocked && mainWidget.offsetHeight > 0) {
        mainWidget.style.minHeight = mainWidget.offsetHeight + 'px';
        mainWidgetHeightLocked = true;
      }

      // Lock badge dimensions on first swap so clearing innerHTML doesn't collapse it
      if (badge && !badgeSizeLocked && badge.offsetHeight > 0 && badge.offsetWidth > 0) {
        badge.style.minHeight = badge.offsetHeight + 'px';
        badge.style.minWidth = badge.offsetWidth + 'px';
        badgeSizeLocked = true;
      }

      // 1. Start fade-out
      targets.forEach(el => el.classList.add('is-reloading'));

      // 2. After fade-out settles, update attrs + wipe content + tell Stamped to reload
      setTimeout(() => {
        targets.forEach(el => {
          applyStampedProduct(el, product);
          // Clear Stamped's injected content so it redraws from the new attrs
          el.innerHTML = '';
        });

        reloadStamped();

        // 3. Fade back in once Stamped repopulates (or after safety timeout)
        targets.forEach(el => {
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            observer.disconnect();
            clearTimeout(safety);
            requestAnimationFrame(() => el.classList.remove('is-reloading'));
          };
          const observer = new MutationObserver((muts) => {
            // Only finish once Stamped has injected real children
            if (el.children.length > 0) finish();
          });
          observer.observe(el, { childList: true });
          const safety = setTimeout(finish, 2500);
        });
      }, 260);

      lastStampedHandle = product.handle;
    }

    function refreshComplementary(product) {
      if (!product) return;
      if (lastComplementaryHandle === product.handle) return;

      const recommendations = configurator.querySelector('product-recommendations.complementary-products');
      if (!recommendations) return;

      const currentUrl = recommendations.getAttribute('data-url');
      if (!currentUrl) return;

      const newUrl = currentUrl.replace(/(\?|&)product_id=\d+/, `$1product_id=${product.id}`);
      recommendations.setAttribute('data-url', newUrl);

      if (complementaryAbortController) complementaryAbortController.abort();
      complementaryAbortController = new AbortController();

      lastComplementaryHandle = product.handle;
      const requestedHandle = product.handle;

      fetch(newUrl, { signal: complementaryAbortController.signal })
        .then(res => res.text())
        .then(responseText => {
          if (lastComplementaryHandle !== requestedHandle) return;
          const sectionHTML = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector('.shopify-section');
          if (!sectionHTML) return;
          const newRecs = sectionHTML.querySelector('product-recommendations');
          if (newRecs && newRecs.innerHTML.trim().length) {
            // Unhide before assigning innerHTML: product-complementary's
            // connectedCallback initializes its Flickity carousel synchronously
            // on upgrade, and it measures zero (cards never show) if the
            // element or its wrapper is still display:none at that point.
            recommendations.removeAttribute('hidden');
            if (complementaryBlock) complementaryBlock.removeAttribute('hidden');
            recommendations.innerHTML = newRecs.innerHTML;
            recommendations.dispatchEvent(new CustomEvent('recommendations:loaded'));
          } else {
            recommendations.innerHTML = '';
            recommendations.setAttribute('hidden', '');
            recommendations.dispatchEvent(new CustomEvent('is-empty'));
          }
        })
        .catch(e => {
          if (e.name !== 'AbortError') console.error('[Complementary refresh]', e);
        });
    }

    // Hide the bordered block wrapper whenever the recommendations element is
    // empty (no complementary products for the current product), and bring it
    // back when a later product switch does return products. Both theme.js
    // (initial load) and refreshComplementary dispatch these events.
    const complementaryEl = configurator.querySelector('product-recommendations.complementary-products');
    const complementaryBlock = complementaryEl && complementaryEl.closest('.complementary-block');
    if (complementaryEl && complementaryBlock) {
      complementaryEl.addEventListener('is-empty', () => complementaryBlock.setAttribute('hidden', ''));
      complementaryEl.addEventListener('recommendations:loaded', () => complementaryBlock.removeAttribute('hidden'));
      if (complementaryEl.hasAttribute('hidden')) complementaryBlock.setAttribute('hidden', '');
    }

    const toNoDecimalsFormat = (fmt) => fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, '{{amount_no_decimals_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, '{{amount_no_decimals_with_space_separator}}')
      .replace(/\{\{\s*amount\s*\}\}/g, '{{amount_no_decimals}}');
    const formatMoney = (cents, format) => {
      const fmt = format || theme.settings.moneyFormat;
      const effective = cents % 100 === 0 ? toNoDecimalsFormat(fmt) : fmt;
      return theme.Currency.formatMoney(cents, effective);
    };

    function updatePrice() {
      const p = state.handle ? productData[state.handle] : null;
      const price = p ? p.price : 0;
      const compareAt = p && p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : 0;

      totalPriceEl.textContent = formatMoney(price);

      if (totalCompareAtEl) {
        if (compareAt) {
          totalCompareAtEl.style.display = 'inline';
          totalCompareAtEl.textContent = formatMoney(compareAt);
        } else {
          totalCompareAtEl.style.display = 'none';
        }
      }
    }

    // Shopify keeps the real country of origin on the inventory item, which Liquid
    // can't read, so country_of_origin comes from the product's
    // custom.country_of_origin metafield. Accepts the ISO code or the spelled-out
    // country so it works whichever way the metafield gets populated.
    function isMadeInCanada(product) {
      const raw = product && product.country_of_origin;
      const origin = (typeof raw === 'string' ? raw : '').trim().toUpperCase();
      return origin === 'CA' || origin === 'CANADA';
    }

    function collectAddonHandles() {
      const handles = [];
      addonCheckboxes.forEach(cb => {
        if (!cb.checked) return;
        let handle = cb.dataset.handle;
        const wrapper = cb.closest('.addon-wrapper');
        const giftCb = wrapper && wrapper.querySelector('.gift-checkbox');
        if (giftCb && giftCb.checked) handle = giftCb.dataset.handle;
        const swapCb = wrapper && wrapper.querySelector('.swap-checkbox:checked');
        if (swapCb) handle = swapCb.dataset.handle;
        handles.push(handle);
      });
      return handles;
    }

    // Must produce the exact same URLs as Liquid's `image_url: width: N`
    // (query param, not the legacy `_WxH` filename suffix) so the slide the
    // server rendered and the slide we rebuild here hit the same cache entry.
    function getResizedImage(url, size) {
      if (!url) return '';
      const width = parseInt(size, 10);
      if (!width) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    // Keep in sync with the widths/sizes on the Liquid-rendered main image in
    // sections/product-allinone.liquid.
    const MAIN_IMAGE_WIDTHS = [400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2160];
    const MAIN_IMAGE_SIZES = '(max-width: 991px) calc(100vw - 40px), max(440px, 60vh)';

    function buildMainSrcset(url, maxWidth) {
      if (!url) return '';
      return MAIN_IMAGE_WIDTHS
        .filter(w => !maxWidth || w <= maxWidth)
        .map(w => getResizedImage(url, w) + ' ' + w + 'w')
        .join(', ');
    }

    // Pick the largest available mp4 source (falls back to whatever exists)
    function pickVideoSource(sources) {
      if (!sources || !sources.length) return null;
      const mp4 = sources.filter(s => (s.mime_type || '').indexOf('mp4') !== -1);
      const pool = mp4.length ? mp4 : sources;
      return pool.reduce((best, s) => (!best || (s.width || 0) > (best.width || 0) ? s : best), null);
    }

    function buildMainSlide(item, index) {
      const slide = document.createElement('div');
      slide.className = 'main-image-slide';

      if (item.type === 'video') {
        const source = pickVideoSource(item.sources);
        if (source) {
          const video = document.createElement('video');
          video.className = 'main-image main-video';
          video.autoplay = true;
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.controls = false;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.preload = 'auto';
          if (item.preview) video.poster = getResizedImage(item.preview, '1080x');
          const sourceEl = document.createElement('source');
          sourceEl.src = source.url;
          sourceEl.type = source.mime_type || 'video/mp4';
          video.appendChild(sourceEl);
          slide.appendChild(video);
          // Some browsers won't honor the autoplay attribute on a freshly-created
          // element; nudge it once it's in the DOM (muted, so this is permitted).
          requestAnimationFrame(() => { video.play().catch(() => {}); });
          return slide;
        }
        // No usable source: fall through to render the preview image instead
      }

      const mainImg = document.createElement('img');
      mainImg.className = 'main-image';
      mainImg.loading = 'eager';
      mainImg.fetchPriority = index === 0 ? 'high' : 'low';
      mainImg.src = getResizedImage(item.preview, '1080x');
      const srcset = buildMainSrcset(item.preview, item.preview_width);
      if (srcset) {
        mainImg.srcset = srcset;
        mainImg.sizes = MAIN_IMAGE_SIZES;
      }
      slide.appendChild(mainImg);
      return slide;
    }

    function updateImageGallery() {
      const product = productData[state.handle];
      if (!product) return;

      const media = product.media || [];

      // Mixed media (images + videos) makes index-based reuse fragile, so rebuild.
      mainImageWrapper.innerHTML = '';
      thumbnailsWrapper.innerHTML = '';

      media.forEach((item, index) => {
        mainImageWrapper.appendChild(buildMainSlide(item, index));

        const thumbImg = document.createElement('img');
        thumbImg.className = 'thumbnail';
        if (item.type === 'video') thumbImg.classList.add('is-video');
        thumbImg.dataset.index = index;
        thumbImg.src = getResizedImage(item.preview, '400x');
        thumbImg.classList.toggle('active', index === 0);
        thumbnailsWrapper.appendChild(thumbImg);
      });

      mainImageWrapper.scrollLeft = 0;
      requestAnimationFrame(() => {
          mainImageWrapper.scrollLeft = 0;
      });
    }

    // Keep the active thumbnail in sync with the slide the user has swiped to,
    // so a genuine resize re-centers on the right image (not always the first).
    function syncActiveThumb() {
      const slides = mainImageWrapper.querySelectorAll('.main-image-slide');
      if (!slides.length) return;
      const center = mainImageWrapper.scrollLeft + mainImageWrapper.clientWidth / 2;
      let index = 0, best = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs((slide.offsetLeft + slide.offsetWidth / 2) - center);
        if (dist < best) { best = dist; index = i; }
      });
      thumbnailsWrapper.querySelectorAll('.thumbnail').forEach((t, i) => {
        t.classList.toggle('active', i === index);
      });
    }

    let scrollSyncRaf = null;
    mainImageWrapper.addEventListener('scroll', () => {
      if (scrollSyncRaf) return;
      scrollSyncRaf = requestAnimationFrame(() => {
        scrollSyncRaf = null;
        syncActiveThumb();
      });
    });

    let lastViewportWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      // Mobile browsers fire resize when the URL bar shows/hides during vertical
      // page scrolling — width is unchanged, only height. Re-centering on those
      // events yanks the carousel back to the active slide, so ignore them.
      if (window.innerWidth === lastViewportWidth) return;
      lastViewportWidth = window.innerWidth;

      const activeThumb = thumbnailsWrapper.querySelector('.thumbnail.active');
      if (!activeThumb) return;
      const index = Array.from(thumbnailsWrapper.querySelectorAll('.thumbnail')).indexOf(activeThumb);
      const targetSlide = mainImageWrapper.querySelectorAll('.main-image-slide')[index];
      if (targetSlide) mainImageWrapper.scrollTo({ left: targetSlide.offsetLeft, top: 0, behavior: 'auto' });
    });

    function updateUI() {
      // Find currently selected radio
      const selectedRadio = configurator.querySelector(`input[name="razor-${sectionId}"]:checked`);
      if (selectedRadio) {
        state.handle = selectedRadio.value;
        state.colorName = selectedRadio.dataset.colorName;

        const p = productData[state.handle];

        if (p && !p.available) {
          addToCartBtn.disabled = true;
          addToCartBtn.querySelector('.btn-text').firstChild.textContent = 'Sold Out';
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.querySelector('.btn-text').firstChild.textContent = 'Add to Cart';
        }

        const override = blockOverrides[state.handle] || {};

        // 1. Update Heading: block header > section heading > product title
        const headingEl = configurator.querySelector('.configurator-title');
        if (headingEl) {
          if (override.header && override.header.trim() !== '') {
            headingEl.textContent = override.header;
          } else if (configHeading && configHeading.trim() !== '') {
            headingEl.textContent = configHeading;
          } else if (p) {
            headingEl.textContent = p.title;
          }
        }

        // 2. Update Description: block override > product description
        if (productDescriptionEl) {
          if (override.description && override.description.trim() !== '') {
            productDescriptionEl.innerHTML = override.description;
          } else if (p) {
            productDescriptionEl.innerHTML = p.description;
          }
        }

        if (canadaBadge) canadaBadge.hidden = !isMadeInCanada(p);

        if(selectedColorNameEl) selectedColorNameEl.textContent = state.colorName;
        updateImageGallery();
        updatePrice();
      }
    }

    // --- DRAWER LOGIC ---
    let drawerCloseTimeout; // Variable to store the cleanup timer

    function openDrawer(element) {
      // If user clicks another item rapidly, cancel the cleanup so we don't accidentally wipe the new image
      if (drawerCloseTimeout) clearTimeout(drawerCloseTimeout);

      const handle = element.dataset.handle;
      const product = productData[handle];
      if (!product) return;

      document.body.classList.add('no-scroll');
      drawerImg.src = element.dataset.image || product.featured_image;

      // Use the override title from dataset if available, otherwise default to product.title
      drawerTitle.textContent = element.dataset.title || product.title;

      // Check for overridden description in hidden div
      const hiddenDesc = element.closest('.addon-item').querySelector('.js-addon-description-content');
      if (hiddenDesc && hiddenDesc.innerHTML.trim() !== "") {
         drawerDescription.innerHTML = hiddenDesc.innerHTML;
      } else {
         drawerDescription.innerHTML = product.description;
      }

      drawer.classList.add('is-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('no-scroll');

      // Set timeout to clear image AFTER animation (0.4s)
      // This ensures next time it opens, it's blank/grey until new image loads
      drawerCloseTimeout = setTimeout(() => {
        // Reset to a transparent 1x1 pixel to avoid "broken image" icon
        drawerImg.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
      }, 400);
    }

    // --- CART LOGIC ---
    function handleAddToCart() {
      const mainProduct = productData[state.handle];
      if (!state.handle || !mainProduct) { alert('Please select a razor.'); return; }

      const items = [{ id: mainProduct.variants[0].id, quantity: 1 }];
      collectAddonHandles().forEach(h => {
        if (productData[h]) items.push({ id: productData[h].variants[0].id, quantity: 1 });
      });

      // Mirror the theme's native button loading state
      addToCartBtn.setAttribute('aria-busy', 'true');
      addToCartBtn.disabled = true;

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
        bubbles: true, detail: { sections: sectionsToBundle }
      }));

      fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: sectionsToBundle, sections_url: window.location.pathname })
      })
      .then(res => res.json())
      .then(async (parsedState) => {
          const cartJson = await (await fetch(theme.routes.cart_url, theme.utils.fetchConfig('json', 'GET'))).json();
          cartJson.sections = parsedState.sections;
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart: cartJson });
          document.querySelectorAll('cart-count').forEach(el => {
              el.innerText = cartJson.item_count;
              el.hidden = cartJson.item_count === 0;
          });
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
          document.querySelector('cart-drawer')?.show();
      })
      .catch(err => console.error('Cart error:', err))
      .finally(() => {
          addToCartBtn.removeAttribute('aria-busy');
          addToCartBtn.disabled = false;
      });
    }

    // --- INIT ---
    function init() {
      razorInputs.forEach(r => r.addEventListener('change', () => {
        updateUI();
        refreshStampedWidgets(productData[state.handle]);
        refreshComplementary(productData[state.handle]);
      }));

      configurator.addEventListener('click', (e) => {
        const infoIcon = e.target.closest('.info-icon');
        if (infoIcon) {
          e.preventDefault();
          openDrawer(infoIcon);
          return;
        }
        const thumb = e.target.closest('.thumbnail');
        if (thumb && thumbnailsWrapper.contains(thumb)) {
          const index = Number(thumb.dataset.index);
          const slide = mainImageWrapper.querySelectorAll('.main-image-slide')[index];
          if (slide) mainImageWrapper.scrollTo({ left: slide.offsetLeft, top: 0, behavior: 'auto' });
          thumbnailsWrapper.querySelectorAll('.thumbnail').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        }
      });

      function setGiftVisibility(wrapper, visible) {
        if (!wrapper) return;
        const giftOption = wrapper.querySelector('.gift-option');
        if (!giftOption) return;
        giftOption.classList.toggle('is-visible', visible);
        if (!visible) {
          const giftCb = giftOption.querySelector('.gift-checkbox');
          if (giftCb) giftCb.checked = false;
        }
      }

      function uncheckOtherBlades(currentCb) {
        configurator.querySelectorAll('.blade-checkbox').forEach(other => {
          if (other !== currentCb) {
            other.checked = false;
            setGiftVisibility(other.closest('.addon-wrapper'), false);
          }
        });
      }

      function setSwapVisibility(wrapper, visible) {
        if (!wrapper) return;
        const swapOpts = wrapper.querySelector('.swap-options');
        if (!swapOpts) return;
        swapOpts.style.display = visible ? 'block' : 'none';
        if (!visible) {
          swapOpts.querySelectorAll('.swap-checkbox').forEach(s => s.checked = false);
        }
      }

      configurator.addEventListener('change', (e) => {
        const bladeCb = e.target.closest('.blade-checkbox');
        if (bladeCb) {
          if (e.target.checked) uncheckOtherBlades(e.target);
          setGiftVisibility(bladeCb.closest('.addon-wrapper'), e.target.checked);
          updatePrice();
          return;
        }
        const swapCb = e.target.closest('.swap-checkbox');
        if (swapCb) {
          if (e.target.checked) {
            const wrapper = swapCb.closest('.addon-wrapper');
            wrapper.querySelectorAll('.swap-checkbox').forEach(s => {
              if (s !== swapCb) s.checked = false;
            });
          }
          updatePrice();
          return;
        }
        const addonCb = e.target.closest('.addon-checkbox');
        if (addonCb && !addonCb.classList.contains('blade-checkbox')) {
          setSwapVisibility(addonCb.closest('.addon-wrapper'), e.target.checked);
          updatePrice();
        }
      });

      addToCartBtn.addEventListener('click', handleAddToCart);
      drawerCloseBtn.addEventListener('click', closeDrawer);
      drawerOverlay.addEventListener('click', closeDrawer);

      // Set initial addon prices
      addonCheckboxes.forEach(cb => {
          const p = productData[cb.dataset.handle];
          if(p) cb.closest('.addon-item').querySelector('.addon-price').textContent = `+${formatMoney(p.price)}`;
      });

      updateUI();
      primeStampedWidgets(productData[state.handle]);
    }

    init();
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('.configurator-section[data-section-id]').forEach(initConfigurator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is reloaded
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target) initAll(e.target);
  });
})();
